import { AxiosRequestConfig, AxiosResponse } from "axios";
import { IHttpRequestable, IPrefetchable, instanceOfIPrefetchable, HttpClient } from "../utilities";
import { LoggerFactory } from "../utilities/logger";

export class HttpRepository implements IPrefetchable {
  public constructor(protected readonly _client: IHttpRequestable = new HttpClient()) {
  }

  get shouldPrefetch(): boolean {
    return instanceOfIPrefetchable(this._client)
      ? this._client.shouldPrefetch
      : false;
  }

  set shouldPrefetch(value: boolean) {
    if (!instanceOfIPrefetchable(this._client)) {
      throw new Error("prefetchできません.");
    }
    this._client.shouldPrefetch = value;
  }

  protected applyPrefetchNecessity(...instances: any[]): void {
    for (const i in instances) {
      if (instanceOfIPrefetchable(instances[i])) {
        instances[i].shouldPrefetch = this.shouldPrefetch;
      } else if (this.shouldPrefetch) {
        this._privateLogger.warn("IPrefetcheableを実装してないのでプリフェッチできません.通常のフェッチを実行します.[" + i + "]" + instances[i].toString());
      }
    }
  }

  protected async fetch<TClient, TResult = any>(client: TClient, fetch: (c: TClient) => Promise<TResult>): Promise<TResult> {
    this.applyPrefetchNecessity(client);
    return fetch(client);
  }

  protected async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._client.get(
      url,
      config,
    );
  }

  protected async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._client.post(
      url,
      data,
      config,
    );
  }

  private readonly _privateLogger = LoggerFactory.getLogger();
}
